var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "#F6F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9193 12.5013C12.9193 8.58929 16.0906 5.41797 20.0026 5.41797C23.9146 5.41797 27.0859 8.58929 27.0859 12.5013C27.0859 16.4133 23.9146 19.5846 20.0026 19.5846C16.0906 19.5846 12.9193 16.4133 12.9193 12.5013ZM20.0026 7.91797C17.4713 7.91797 15.4193 9.97 15.4193 12.5013C15.4193 15.0326 17.4713 17.0846 20.0026 17.0846C22.5339 17.0846 24.5859 15.0326 24.5859 12.5013C24.5859 9.97 22.5339 7.91797 20.0026 7.91797Z",
    fill: "#5463FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3359 24.5846C11.2649 24.5846 9.58594 26.2636 9.58594 28.3346V30.3151C9.58594 30.3453 9.60779 30.371 9.63755 30.3758C16.5021 31.4966 23.5031 31.4966 30.3677 30.3758C30.3974 30.371 30.4193 30.3453 30.4193 30.3151V28.3346C30.4193 26.2636 28.7403 24.5846 26.6693 24.5846H26.1012C26.0572 24.5846 26.0136 24.5916 25.9718 24.6052L24.5293 25.0762C21.5879 26.0367 18.4173 26.0367 15.4759 25.0762L14.0334 24.6052C13.9916 24.5916 13.948 24.5846 13.9041 24.5846H13.3359ZM7.08594 28.3346C7.08594 24.8829 9.88416 22.0846 13.3359 22.0846H13.9041C14.2115 22.0846 14.5171 22.1333 14.8094 22.2287L16.2519 22.6997C18.6891 23.4955 21.3162 23.4955 23.7533 22.6997L25.1958 22.2287C25.4881 22.1333 25.7937 22.0846 26.1012 22.0846H26.6693C30.1211 22.0846 32.9193 24.8829 32.9193 28.3346V30.3151C32.9193 31.5705 32.0095 32.6409 30.7705 32.8432C23.6391 34.0075 16.3661 34.0075 9.23472 32.8432C7.99574 32.6409 7.08594 31.5705 7.08594 30.3151V28.3346Z",
    fill: "#5463FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserBlue);
export default __webpack_public_path__ + "static/media/UserBlue.ea2692d18c92e136bd97c147c088357f.svg";
export { ForwardRef as ReactComponent };